import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const customStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=DM+Sans:wght@400;500&display=swap');
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(5deg); }
  }
`;

export default function NotFound() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = customStyles;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0f1c 0%, #0d1525 100%)',
      fontFamily: "'DM Sans', sans-serif",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px',
      textAlign: 'center'
    }}>
      <div>
        {/* Animated 404 */}
        <div style={{
          fontSize: '120px',
          fontFamily: "'Outfit', sans-serif",
          fontWeight: '800',
          background: 'linear-gradient(135deg, #667eea, #f093fb)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          marginBottom: '24px',
          animation: 'float 3s ease-in-out infinite'
        }}>
          404
        </div>

        <h1 style={{
          fontFamily: "'Outfit', sans-serif",
          fontSize: '32px',
          fontWeight: '600',
          color: 'white',
          marginBottom: '16px'
        }}>
          Page not found
        </h1>

        <p style={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: '18px',
          marginBottom: '40px',
          maxWidth: '400px'
        }}>
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" style={{
            padding: '14px 32px',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            borderRadius: '12px',
            color: 'white',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: '600',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
          }}>
            Go Home
          </Link>
          <Link to="/dashboard" style={{
            padding: '14px 32px',
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRadius: '12px',
            color: 'white',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: '500'
          }}>
            Dashboard
          </Link>
        </div>

        {/* Logo */}
        <div style={{
          marginTop: '80px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          opacity: 0.5
        }}>
          <div style={{
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '16px'
          }}>
            🧠
          </div>
          <span style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: '16px',
            fontWeight: '600',
            color: 'white'
          }}>
            BrainForge
          </span>
        </div>
      </div>
    </div>
  );
}
